import { cn } from "../../utils/classnames"
import { LeadScoreCategory } from "../../../types"
import { CATEGORY_CONFIG, CATEGORIES } from "./category-helpers"

interface Props {
  activeCategory: LeadScoreCategory | null
  onChange: (category: LeadScoreCategory | null) => void
}

const CategoryFilterBar = ({ activeCategory, onChange }: Props) => {
  const tabs = [
    { id: null, label: "All" },
    ...CATEGORIES.map(c => ({
      id: c as LeadScoreCategory,
      label: CATEGORY_CONFIG[c].labelPlural
    }))
  ]

  return (
    <div className="flex flex-wrap gap-2">
      {tabs.map(tab => {
        const isActive =
          tab.id === activeCategory ||
          (tab.id === null && activeCategory === null)
        const activeClass =
          tab.id === null
            ? "bg-primary-100 border-primary-400 text-primary-600"
            : CATEGORY_CONFIG[tab.id].pillActiveClass

        return (
          <button
            key={tab.id ?? "all"}
            onClick={() => onChange(tab.id)}
            className={cn(
              "px-4 py-1.5 border rounded-full text-sm font-medium transition-all cursor-pointer",
              isActive
                ? activeClass
                : "border-neutral-200 text-neutral-500 hover:border-neutral-400"
            )}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}

export default CategoryFilterBar
